export const QUESTIONNAIRE_CODE = {
  YES_NO_ONCE: "YES_NO_ONCE",
  YES_NO_HAVE: "YES_NO_HAVE",
  YES_NO_INTENTION: "YES_NO_INTENTION",
  ONLY_REMARK: "ONLY_REMARK",

  YES_NO_ONCE_OPTIONAL: "YES_NO_ONCE_OPTIONAL",
  YES_NO_HAVE_OPTIONAL: "YES_NO_HAVE_OPTIONAL",
  YES_NO_INTENTION_OPTIONAL: "YES_NO_INTENTION_OPTIONAL",
  ONLY_REMARK_OPTIONAL: "ONLY_REMARK_OPTIONAL",
};

export const CONSENT_CODE = {
  SUNDAY_MKT: "SUNDAY_MKT",
  SUNDAY_TC: "SUNDAY_TC",
  SUNDAY_PRIVACY: "SUNDAY_PRIVACY",
};

export const CONSENT_TYPE = {
  CHECKBOX: "CHECKBOX",
  PRODUCT_TC: "PRODUCT_TC",
  INSURER_PRIVACY: "INSURER_PRIVACY",
  SUNDAY_TC: "SUNDAY_TC",
  SUNDAY_MKT: "SUNDAY_MKT",
  TRUSTFUL_TC: "TRUSTFUL_TC",
  PRODUCT_V1_TC: "PRODUCT_V1_TC",
  PASSIVE_TEXT_ONLY: "PASSIVE_TEXT_ONLY",
};

export const CONSENT_ADDITIONAL_INFO_TYPE = {
  PDF: "PDF",
  DIALOG: "DIALOG",
  NONE: "NONE",
};

export const PARENT_RELATION_OPTION_VALUE = [
  "FATHER",
  "MOTHER",
  "ELDER_SIBLING",
];

export const BENEFICIARY_RELATION_OPTION_VALUE = [
  "FATHER",
  "MOTHER",
  "ELDER_SIBLING",
  "SIBLING",
  "CHILD",
  "SPOUSE",
  "FIANCEE",
];
